import { useState, useEffect } from 'react';
import { SCREEN_SIZE } from '@constants/common.constants';

export function useIsMobile() {
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === 'undefined') return false;
        return window.innerWidth < SCREEN_SIZE.TABLET;
    });

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < SCREEN_SIZE.TABLET);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return isMobile;
}